import './style.less';
import template from './template.html';

export default function() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: ($scope, $log, $stateParams, ProfileClass, $timeout) => {
      'ngInject';

      const { profile } = ProfileClass.profileComplete;
      const profile_uid = $stateParams.employeeID || $stateParams.id || profile.profile_uid;

      $scope.animate = false;
      ProfileClass.profileGet(profile_uid)
        .then(data => {
          $scope.creditNum = data.gogo;
          $scope.$watch('creditNum', (newVal, oldVal) => {
            if (newVal < oldVal) {
              $('#credits > a').attr('class', 'down');
              $scope.animate = true;
              $timeout(() => {
                $('#credits > a').removeAttr('class', 'down');
                $scope.animate = false;
              }, 1000);
            } else if (newVal > oldVal) {
              $('#credits > a').attr('class', 'up');
              $scope.animate = true;
              $timeout(() => {
                $('#credits > a').removeAttr('class', 'up');
                $scope.animate = false;
              }, 1000);
            }
          });
        })
        .catch($log.error);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/credits/index.js